import { parseM3U } from './m3u.js';

/* Análisis de listas M3U fuera del hilo principal. Las listas pequeñas se analizan directamente (crear un worker
   cuesta más que analizarlas); las grandes, en un worker. Si no hay Workers o falla, se analiza igualmente aquí. */

const BIG = 300000; // caracteres
let seq = 0;

export function parseM3UAsync(text, options = {}) {
    if (typeof Worker === 'undefined' || String(text).length < BIG) {
        return Promise.resolve().then(() => parseM3U(text, options));
    }
    return new Promise((resolve, reject) => {
        let worker;
        try {
            worker = new Worker('dist/m3u-worker.js');
        } catch (e) {
            try { resolve(parseM3U(text, options)); } catch (err) { reject(err); }
            return;
        }
        const id = ++seq;
        const fallback = () => {
            try { worker.terminate(); } catch (e) { /* ya terminado */ }
            try { resolve(parseM3U(text, options)); } catch (err) { reject(err); }
        };
        worker.onmessage = (event) => {
            const msg = event.data || {};
            if (msg.id !== id) return;
            worker.terminate();
            if (msg.ok) resolve(msg.parsed); else reject(new Error(msg.error));
        };
        worker.onerror = fallback;
        worker.postMessage({ id, text, options });
    });
}
